var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.auth)?_c('DashBoard'):_c('v-sheet',[_c('h2',[_vm._v("you have no authorise")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }